import * as React from 'react'
import { ReactElement } from 'react'
import PersonAvatar from '../PersonAvatar'
import useUser from '../../hooks/useUser'
import { useApplicationStyles } from '../../pages/App'

export default function MailboxAvatar(): ReactElement {
    const styles = useApplicationStyles()
    const currentUser = useUser()

    return (
        currentUser?.currentMailboxFullName && (
            <PersonAvatar className={styles.selfCenter} name={currentUser?.currentMailboxFullName} color={'colorful'} size={24} />
        )
    )
}
